const Calendar = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-calendar"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-calendar"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M0,8v-1C0,4.243,2.243,2,5,2h1V1c0-.552,.447-1,1-1s1,.448,1,1v1h8V1c0-.552,.447-1,1-1s1,.448,1,1v1h1c2.757,0,5,2.243,5,5v1H0Zm24,2v9c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5V10H24Zm-12,9c0-.552-.447-1-1-1H6c-.553,0-1,.448-1,1s.447,1,1,1h5c.553,0,1-.448,1-1Zm7-4c0-.552-.447-1-1-1H6c-.553,0-1,.448-1,1s.447,1,1,1h12c.553,0,1-.448,1-1Z" />
    </svg>
  );
};

export default Calendar;
